import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { toLocaleDateTime } from 'src/common/utils/dateUtils';
import { useTariffSummaryLastUpdate } from '../hooks/useTariffSummaryLastUpdate';

const LastUpdateBoxTypography = styled(Typography)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 8),
  verticalAlign: 'bottom',
}));

export const TariffSummaryLastUpdate = () => {
  const { t } = useTranslation();
  const { data } = useTariffSummaryLastUpdate();
  return data ? (
    <LastUpdateBoxTypography
      variant="text4"
      color="text.secondary"
      data-testid="tariffSummaryLastUpdate"
      alignSelf="center"
    >
      {`${t('tariffSummary.lastUpdated')}: ${toLocaleDateTime(data)}`}
    </LastUpdateBoxTypography>
  ) : null;
};
